// extracted by mini-css-extract-plugin
module.exports = {"item":"iO","dark":"iP","light":"iQ","toggle":"iR"};